var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    {
      staticClass: "relative block h-9 sm:h-11 cursor-pointer",
      attrs: { for: _vm.id },
    },
    [
      _c("input", {
        staticClass: "sr-only",
        attrs: { id: _vm.id, type: "checkbox" },
        domProps: { checked: _vm.value },
        on: {
          change: function ($event) {
            return _vm.$emit("input", $event.target.checked)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "relative h-full flex items-center border rounded-full z-20",
        },
        [
          _c(
            "div",
            {
              staticClass: "w-1/2 text-center pl-2",
              class: { "font-semibold": _vm.value },
            },
            [_vm._v("\n      " + _vm._s(_vm.labels[0]) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "w-1/2 text-center pr-2",
              class: { "font-semibold": !_vm.value },
            },
            [_vm._v("\n      " + _vm._s(_vm.labels[1]) + "\n    ")]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "absolute left-0 inset-y-0 w-1/2 bg-grey border rounded-full z-10 transform transition-transform duration-200",
        style: {
          width: "calc(50% + 0.5rem)",
          transform: _vm.value
            ? "translateX(0)"
            : "translateX(calc(100% - 1rem))",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }